export default "__VITE_ASSET__85cc27f0__"